// extracted by mini-css-extract-plugin
export default {"lifeNetApiKey":"ClientsEditPopup_lifeNetApiKey_irZVe","lifeNetApiKeyButton":"ClientsEditPopup_lifeNetApiKeyButton_ciVWT","lifeNetNoApiKey":"ClientsEditPopup_lifeNetNoApiKey_kj5sO"};